import { Selection } from '../Tree/types';
import type { TreeState } from '../Tree/useTreeState';
import { Company } from './company';
import { Location } from './location';
import { Reseller } from './reseller';
import { Box, Typography } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

import type { Operation } from '@/types/general';

type PanelProps = {
    selection: TreeState;
    operation: Operation;
    onSuccess: () => void;
};

export type ManageProps = {
    operation: Operation;
    /**
     * ID must always be provided - even in create mode.
     * Prevents error possibilities +
     */
    id?: number;
    /**
     * Perform operations in the parent component after the form is submitted successfully.
     */
    onSuccess: () => void;
};

const SELECTION_COMPONENTS = {
    [Selection.Company]: Company,
    [Selection.Reseller]: Reseller,
    [Selection.Location]: Location,
};

export const Panel = ({ selection, operation, onSuccess }: PanelProps) => {
    const Component = selection.type && SELECTION_COMPONENTS[selection.type];

    return Component ? (
        <Component operation={operation} id={selection[selection.type!]!} onSuccess={onSuccess} />
    ) : (
        <Box
            height='100%'
            width='100%'
            display='flex'
            justifyContent='center'
            alignItems='center'
            flexDirection='column'>
            <SearchIcon sx={{ fontSize: '50px' }} color='secondary' />
            <Typography variant='h3' color='secondary' textAlign='center'>
                Use the left-hand menu to make a selection
            </Typography>
        </Box>
    );
};
